import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";
import { CheckCircle2 } from "lucide-react";
import { api, errorMessage } from "../lib/api";
import { useSeo } from "../lib/seo";
import { FormStatus } from "../components/forms/Fields";

export default function Pay() {
  useSeo("Pay online");
  const { token } = useParams();
  const [p, setP] = useState(null);
  const [error, setError] = useState("");
  const [status, setStatus] = useState(null);

  useEffect(() => { api.get(`/pay/${token}`).then((r) => setP(r.data)).catch((e) => setError(errorMessage(e))); }, [token]);

  const paid = p?.status === "paid";
  return (
    <section className="bg-cream text-ink py-20 md:py-28 font-sans">
      <div className="max-w-lg mx-auto px-6">
        <p className="lbl text-teal">Secure payment</p>
        <h1 className="mt-4 !text-5xl">Pay online</h1>
        {error && <div className="mt-8"><FormStatus status={{ type: "error", title: "Payment link problem", text: error }} testid="pay-error" /></div>}
        {p && (
          <div className="mt-10 bg-paper rounded-2xl p-6" data-testid="pay-card">
            <p className="text-slate">For {p.client_name}</p>
            <p className="font-display text-2xl mt-1">{p.description}</p>
            <p className="mt-4 text-4xl font-display" data-testid="pay-amount">${p.amount} <span className="text-base font-sans text-slate">USD</span></p>
            <div className="mt-8">
              {paid && <p className="flex items-center gap-2 text-teal font-semibold" role="status" data-testid="pay-paid"><CheckCircle2 className="w-5 h-5" aria-hidden="true" /> Paid. Thank you!</p>}
              {!paid && !p.paypal_client_id && <p className="text-slate" data-testid="pay-unavailable">Online payment isn&apos;t available yet. Please contact <span className="break-all">deafeducationconsultingllc@gmail.com</span> or 724-454-6332.</p>}
              {!paid && p.paypal_client_id && (
                <PayPalScriptProvider options={{ clientId: p.paypal_client_id, currency: "USD", intent: "capture" }}>
                  <PayPalButtons
                    style={{ layout: "vertical", shape: "pill", color: "gold" }}
                    createOrder={() => api.post(`/pay/${token}/order`).then((r) => r.data.id)}
                    onApprove={(d) => api.post(`/pay/${token}/capture`, { order_id: d.orderID }).then(() => { setP({ ...p, status: "paid" }); setStatus(null); })
                      .catch((e) => setStatus({ type: "error", title: "Payment not completed", text: errorMessage(e) }))}
                    onError={() => setStatus({ type: "error", title: "Payment not completed", text: "PayPal had a problem. Please try again." })}
                  />
                </PayPalScriptProvider>
              )}
            </div>
            {status && <div className="mt-6"><FormStatus status={status} testid="pay-status" /></div>}
          </div>
        )}
        <p className="mt-6 text-sm text-slate">Payments are processed by PayPal. Deaf Education Consulting LLC never sees your card details.</p>
      </div>
    </section>
  );
}
